import { Landmark, Palette, Megaphone, LineChart, Tent, RadioTower, Newspaper, Building2, Bird, User } from "lucide-react";

export const SERVICE_ICONS = {
  hq: Landmark,
  branding: Palette,
  marketing: Megaphone,
  consulting: LineChart,
  experiential: Tent,
  contact: RadioTower,
  drilldown: Newspaper,
  "kaity-owl-shrine": Bird,
  citizen: User,
};

export function iconFor(slug) {
  return SERVICE_ICONS[slug] || Building2;
}
